import { createStyles } from "antd-style";

export const useAppHeaderLayoutStyles = createStyles(({ token, css }: any) => ({
  section: css`
    height: 100%;
    height: ${token.heightHeader};
  `,
  body: css`
    padding-block: 0;
    display: flex;
    justify-content: space-between;
  `,
}));
